import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { BlockConnector } from './BlockConnector';
import { BlockContextProvider, useBlockContext } from './BlockContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function RootZone(_ref) {
  var _ref2;
  var piletApi = _ref.piletApi,
    allViews = _ref.allViews,
    startingViewRID = _ref.startingViewRID,
    contractData = _ref.contractData,
    onCompleteInteraction = _ref.onCompleteInteraction,
    onCancelInteraction = _ref.onCancelInteraction;
  var _useBlockContext = useBlockContext(),
    contractDataSourcesFromParentBlock = _useBlockContext.contractDataSources;
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    viewFromState = _React$useState2[0],
    setSelectedView = _React$useState2[1];
  var firstView = allViews[0];
  var activeView = (_ref2 = viewFromState !== null && viewFromState !== void 0 ? viewFromState : allViews.find(function (x) {
    return x.rid === startingViewRID;
  })) !== null && _ref2 !== void 0 ? _ref2 : firstView;
  var completeInteraction = React.useCallback(function (data) {
    onCompleteInteraction === null || onCompleteInteraction === void 0 || onCompleteInteraction(data);
  }, [onCompleteInteraction]);
  var cancelInteraction = React.useCallback(function () {
    onCancelInteraction === null || onCancelInteraction === void 0 || onCancelInteraction();
  }, [onCancelInteraction]);
  var contractDataSources = React.useMemo(function () {
    var sources = [];
    if (contractDataSourcesFromParentBlock) {
      sources.push.apply(sources, _toConsumableArray(contractDataSourcesFromParentBlock));
    }
    if (contractData) {
      sources.push(contractData);
    }
    return sources;
  }, [contractData, contractDataSourcesFromParentBlock]);
  return /*#__PURE__*/_jsx(BlockContextProvider, {
    view: activeView,
    piletApi: piletApi,
    blockRID: activeView.rootBlockRID,
    allViews: allViews,
    changeView: setSelectedView,
    completeInteraction: completeInteraction,
    cancelInteraction: cancelInteraction,
    contractSources: contractDataSources,
    children: /*#__PURE__*/_jsx(RootConnector, {})
  });
}
function RootConnector() {
  var _useBlockContext2 = useBlockContext(),
    block = _useBlockContext2.block;
  return /*#__PURE__*/_jsx(BlockConnector, {
    block: block
  });
}